import React from 'react';
import '../../styles/styles.css';

export default function annavaram() {
  return (

    <div className="container mt-4">
        <div className="row">
            {/* Left Large Image Box */}
            <div className="col-md-4 box1">
            <img src="/images/Annavaram.jpg" alt="Sri Veera Venkata SatyaNarayana Swamy" />    
            </div>

           
            {/* Right Information Boxes */}
            <div className="col-md-8">
                <div className="Reg-box2">
                    <p><strong>Auspicious Dates for Satyanarayana Vrata each month<br />
    Full Moon Day/Purnima<br />    
    <br />

  </strong></p>
  <p>Timings of SatyaNarayana Vratam : <a href="https://annavaramdevasthanam.nic.in/SevaDetails/SriVariVratham" target="_blank" rel="noopener noreferrer">
  Annavaram Website
</a>
  </p>
         </div>
            </div>
        </div>

      
        {/* Bottom Full Width Description Box */}
        <div className="row mt-3">
            <div className="col-12 Desc-box3">
             <p>Annavaram is one of the most famous Holy Shrines in India and enjoying second place after Tirupati in Andhra Pradesh. The glory and richness of Lord SATYADEVA was widely described in Revakhanda of Skandapuranam. The presiding deity Lord Satyadeva with his consort Sri Anantha Lakshmi on one Side and with Lord Siva on the other side took his abode on Ratnagiri, which is named after Ratnakara, son of Meru the king of holy mountains. Like in all Divyakshetrams as surrounded and followed by holy rivers, Sri Satyanarayana Swamy at Annavaram is also followed by sacred Pampa River touching the feet of the hill. Lord Satyadeva the god of truth is showering his eternal blessings on mankind in his beautiful manifested form of the DIVINE TRINITY namely Hari Hara Hiranya Garbha Thrimurtyatmaka.Enriched by the installation of SRIMATHRIPATHVIBHUTI VYKHUNTA MAHA NARAYANA YANTRA, which plays a dominant and important role with the power of attraction of both money and men (Dhana Janakarsha). The Peetham of Swamyvaru is highly adorned with the installation of Panchayatana, befitting the glory and sanctity of the deity. This famous yantra is a unique one, the like of which does not exist any where else in India.</p>
            </div>
        </div>

{/* YouTube Section */}
      <div className="row mt-3">
        <div className="col-12">
          <div className="Desc-box3">
            <h2 className="live-header">Annavaram Temple Documentary</h2>
            <div className="youtube-container">
              <iframe
                src="https://www.youtube.com/embed/5PRqhGJlZSo?rel=0&modestbranding=1&showinfo=0"
                title="Annavaram Temple"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerPolicy="strict-origin-when-cross-origin"
                allowFullScreen
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </div>




  )
}
